module.exports = __webpack_public_path__ + "img/icon_arrow_white.188d9dd4.svg";